import React from 'react';
import EstimateSimulator from './EstimateSimulator';

const EstimateModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 backdrop-blur-sm flex items-center justify-center px-4">
      <div className="relative w-full max-w-md sm:max-w-xl max-h-[90vh] bg-neutral-50 rounded-3xl shadow-md overflow-hidden">
        
        {/* 閉じるボタン */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-neutral-400 hover:text-neutral-600 text-3xl font-light"
          aria-label="閉じる"
        >
          ×
        </button>

        {/* 本体 */}
        <div className="px-6 py-8 sm:px-8 overflow-y-auto max-h-[90vh]">
          <EstimateSimulator />
        </div>
      </div>
    </div>
  );
};

export default EstimateModal;
